import { Flex } from "@chakra-ui/react";
import {
	NewOrderRenewReason,
	useNewOrderStore,
} from "../../../stores/order.store";
import PageTitle from "../../../components/PageTitle";
import { CardSelectable } from "./CardSelectable";
import { OrdersNewPageBaseLayout } from "./OrdersNewPageBaseLayout";
import { OrdersNewPageBaseLayoutButton } from "./OrdersNewPageBaseLayoutButton";

export const ChooseRenewReasonLayout = () => {
	const reasonOptions = [
		{ label: "Renouvellement", value: NewOrderRenewReason.RENEW },
		{
			label: "Changement de type d'embout",
			value: NewOrderRenewReason.CHANGE_EARMOLD_TYPE,
		},
		{
			label: "Changement de caractéristiques",
			value: NewOrderRenewReason.CHANGE_CARACTERISTICS,
		},
		{ label: "Suite à une casse", value: NewOrderRenewReason.BROKEN },
		{ label: "Suite à une perte", value: NewOrderRenewReason.LOST },
		{ label: "Autre", value: NewOrderRenewReason.OTHER },
	];
	const { renewReason, setRenewReason } = useNewOrderStore();

	return (
		<OrdersNewPageBaseLayout>
			<Flex direction="column" gap={12} alignItems="center">
				<PageTitle>De quel motif s'agit-il ?</PageTitle>

				<Flex direction="column" gap={4}>
					{reasonOptions &&
						reasonOptions.map((reasonOption) => (
							<CardSelectable
								w="40rem"
								key={reasonOption.value}
								title={reasonOption.label}
								activated={reasonOption.value === renewReason}
								onClick={() => setRenewReason(reasonOption.value)}
								inline
							></CardSelectable>
						))}
				</Flex>

				<OrdersNewPageBaseLayoutButton />
			</Flex>
		</OrdersNewPageBaseLayout>
	);
};
